import {
  checkXtpWasUpdatedWithErrors,
  adaptXtpListFromResponse,
  adaptXtpOptionsListFromResponse,
} from './xtp.adapters';
import {
  GET_XTPS_PENDING,
  GET_XTPS_FULFILLED,
  UPDATE_ERRORS,
  GET_XTP_OPTIONS,
  GET_XTP_OPTIONS_FULFILLED,
  XtpActionTypes,
  XtpState,
} from './xtp.types';

const initialState: XtpState = {
  entities: [],
  xtpOptions: [],
  errors: { xtp: '', xtpOptions: '', },
  ui: {
    isLoading: false,
    wasXtpUpdatedWithErrors: false,
  }
};

export default function xtpReducer(
  state = initialState,
  action: XtpActionTypes,
): XtpState {
  switch (action.type) {
    case GET_XTPS_PENDING:
      return {
        ...state,
        ui: {
        ...state.ui,
        isLoading: true
      }
    };

    case GET_XTPS_FULFILLED:
      return {
        ...state,
        entities: adaptXtpListFromResponse(action.payload.data.data || []),
        ui: {
          ...state.ui,
          isLoading: false
        }
      };

    case GET_XTP_OPTIONS:
        return {
          ...state,
          ui: {
          ...state.ui,
          isLoading: true
        }
      };

    case GET_XTP_OPTIONS_FULFILLED:
      return {
        ...state,
        xtpOptions: adaptXtpOptionsListFromResponse(action.payload.data.data || []),
        ui: {
          ...state.ui,
          isLoading: false
        }
      };

    case UPDATE_ERRORS:
      return {
        ...state,
        errors: action.payload,
        ui: {
          ...state.ui,
          wasXtpUpdatedWithErrors: checkXtpWasUpdatedWithErrors(action.payload)
        }
      };

    default:
      return state;
  }
}
